<template>
  <status-bar v-model="value" :inError="inError">
    <h3 v-if="header.length > 0" class="pt-2">{{ header }}</h3>
    <h3
      v-if="subText.length > 0"
      class="text-body-1 font-italic text--secondary"
    >
      {{ subText }}
    </h3>
    <v-text-field
      ref="textInput"
      :value="value"
      :label="label"
      :tabindex="tabindex"
      :autofocus="autofocus"
      :readonly="readonly"
      :disabled="disabled"
      :outlined="outlined"
      :type="type"
      v-on:input="updateValue($event)"
      :rules="rules"
      @update:error="handleError($event)"
    ></v-text-field>
  </status-bar>
</template>

<script>
import StatusBar from "./StatusBar.vue";

// @ is an alias to /src
export default {
  name: "ResumationTextField",
  components: {
    "status-bar": StatusBar
  },
  data: () => ({
    inError: false
  }),
  props: {
    value: {
      type: [String, Number]
    },
    label: {
      type: String,
      default: ""
    },
    header: {
      type: String,
      default: ""
    },
    subText: {
      type: String,
      default: ""
    },
    tabindex: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ""
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    },
    handleError(evt) {
      this.inError = evt;
    },
    checkValidation() {
      // work around issue where calling form.validate() doesn't trigger the update:error event
      this.inError = !this.$refs.textInput.valid;
    }
  },
  mounted() {},
  computed: {}
};
</script>
